import React from "react";
import axios from "axios";
import { useAuth } from '../../utilities/AuthContext';
import { useNavigation } from '../../utilities/NavigationContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {ConfirmDialog, showSuccessToast, showErrorToast} from '../../utilities/helper';

import Joyride from 'react-joyride';

const EndPoint = process.env.REACT_APP_API_ENDPOINT

const walkThrough = [
  {
    target: '#step1',
    content: "Add new problem here. If there's existing problem it will show up in the dropdown list",
  },
  {
    target: '#step2',
    content: "Choose Category of this issue/problem. ",
  },
  {
    target: '#step3',
    content: 'Enter to Submit the issue/problem. This will be seen by other medical practitioners.',
  },
  {
    target: '#step4',
    content: 'Enter keyword to find an issue/problem that you can review and contribute.',
  }
];

class Library extends React.Component {
  state = {
    problems: {},
    input: "",
    goalInputs: {},
    editingGoals: {},
    editingProblemId: null,
    author: "",
    authorLocked: false,
    collapsedProblems: {},
    categoryMap: {},
    filterCategory: "All",
    showPrintPreview: false,
    selectedCategory: "Chronic Disease",
    matchingProblems: [],
    searchQuery: "",
    run: false,
    jsonInput: "",
    userId: "",
    credits: 0,
    hasSubscription: false
  };

  categoryOptions = [
    { label: "Chronic Disease", color: "bg-sky-200" },
    { label: "Mental Health", color: "bg-purple-200" },
    { label: "Lifestyle", color: "bg-green-200" },
    { label: "Substance Use", color: "bg-red-200" },
    { label: "Preventive", color: "bg-orange-200" },
    { label: "Senior Health", color: "bg-slate-300" },
    { label: "Social", color: "bg-yellow-200" }

  ];

  async componentDidMount() {

    this.checkSubscription();
    this.loadProblems();
    this.fetchUserData();
  
  }


  // check subscription
  checkSubscription = async () => {
    try {
      const res = await axios.get(`${EndPoint}/stripe/subscriptions/history`, {
        withCredentials: true
      });

      const subs = res.data.subscriptions || [];
      const active = subs.some(s =>
        s.status === "active" || s.status === "trialing"
      );
      if (active) {
        this.setState({hasSubscription: true})
      } else {
        this.setState({hasSubscription: false})
        this.props.navigate('/pricing'); 
      }

    } catch (err) {
      console.error("Subscription check error:", err);
      this.props.navigate('/pricing');
    }
  };
  

  fetchUserData = async () => {
    try {
      const respond = await axios.get(`${EndPoint}/user/user_detail`, { withCredentials: true });
      if (respond) {
        this.setState({author: respond.data.firstName + " " + respond.data.lastName, credits:respond.data.credits})
      }
      if (respond.data.onBoarding.library=== true) {
          this.setState({run: false})
      } else {
          this.setState({run: true})
      }

    } catch (error) {
      console.error("Error fetching user data:", error.response?.data || error.message);
    }
  };

  loadProblems = async () => {
    try {
      const res = await axios.get(`${EndPoint}/library`, { withCredentials: true });
      const problemsObj = {};
      const categoryMap = {};
      const collapsedProblems = {};
      res.data.forEach((prob) => {
        problemsObj[prob._id] = prob;
        categoryMap[prob._id] = this.categoryOptions.findIndex(
          (opt) => opt.label === prob.category
        );
        collapsedProblems[prob._id] = true;
      });
      this.setState({ problems: problemsObj, categoryMap, collapsedProblems });
    } catch (err) {
      console.error(err);
      showErrorToast("Failed to load problems.");
    }
  };

  finishOnboard = async (data) => {
    try {
      const { status } = data;
      if (status === 'ready') {
        this.setState({ run: false }); // Stop the tour when finished or skipped
      
      // Make the POST request to the onboarding endpoint
      await axios.post(
        `${EndPoint}/user/onboard`,
        { path: 'library' },
        { withCredentials: true }
      );
  
      // Show a success toast notification
      showSuccessToast("Library of Care plan walkthrough complete!");
    }
    } catch (error) {
      console.error("Error updating onboarding:", error.response?.data || error.message);
      showErrorToast("Failed to update onboarding. Please try again.");
    }
  };

  handleInputChange = (e) => {
    const input = e.target.value;
    this.setState({ input });
  
    if (input.trim()) {
      const matchingProblems = Object.values(this.state.problems).filter(prob =>
        prob.text.toLowerCase().includes(input.toLowerCase())
      );
      this.setState({ matchingProblems });
    } else {
      this.setState({ matchingProblems: [] });
    }
  };

  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  };

  submitFullEntry = async () => {
    try {
      const parsed = JSON.parse(this.state.jsonInput);
      const res = await axios.post(`${EndPoint}/library/full`, parsed, { withCredentials: true });
  
      const saved = res.data;
      this.setState((prev) => ({
        jsonInput: "",
        problems: { ...prev.problems, [saved._id]: saved },
        categoryMap: {
          ...prev.categoryMap,
          [saved._id]: this.categoryOptions.findIndex(cat => cat.label === saved.category)
        },
        collapsedProblems: { ...prev.collapsedProblems, [saved._id]: true }
      }));
  
      showSuccessToast("Full entry added successfully!");
    } catch (err) {
      console.error(err);
      showErrorToast("Failed to submit full JSON. Make sure it's valid.");
    }
  };
  
  addProblemwithAI = async () => {
    const { input, author, selectedCategory } = this.state;
    if (!input.trim()) return;
  
    try {
      const newProblem = {
        text: input.trim(),
        author,
        category: selectedCategory
      };
      const res = await axios.post(`${EndPoint}/library/AI`, newProblem, { withCredentials: true });
      const saved = res.data.saved;
      const creditResult = res.data.creditResult;
      const creditUsed = creditResult.amount;
      const reason = creditResult.reason;
      toast.info(`${creditUsed} credits was used to ${reason}`, { autoClose: 1500 });

      console.log(res.data)
      this.setState((prev) => ({
        input: "",
        problems: { ...prev.problems, [saved._id]: saved },
        categoryMap: { 
          ...prev.categoryMap, 
          [saved._id]: this.categoryOptions.findIndex(cat => cat.label === saved.category) 
        }, // Correctly finds and assigns the category index
        collapsedProblems: { ...prev.collapsedProblems, [saved._id]: true },
        matchingProblems: []
      }));
      
    } catch (err) {
      console.error(err);
      showErrorToast("Failed to add problem.");
    }
  };

  addProblem = async () => {
    const { input, author, selectedCategory } = this.state;
    if (!input.trim()) return;
  
    try {
      const newProblem = {
        text: input.trim(),
        author,
        category: selectedCategory
      };
      const res = await axios.post(`${EndPoint}/library`, newProblem, { withCredentials: true });
      const saved = res.data;
      this.setState((prev) => ({
        input: "",
        problems: { ...prev.problems, [saved._id]: saved },
        categoryMap: { 
          ...prev.categoryMap, 
          [saved._id]: this.categoryOptions.findIndex(cat => cat.label === saved.category) 
        }, // Correctly finds and assigns the category index
        collapsedProblems: { ...prev.collapsedProblems, [saved._id]: true },
        matchingProblems: []
      }));
      
    } catch (err) {
      console.error(err);
      showErrorToast("Failed to add problem.");
    }
  };

  
  updateProblem = async (id, newText) => {
    try {
      const updated = { ...this.state.problems[id], text: newText };
      await axios.put(`${EndPoint}/library/${id}`, updated, { withCredentials: true });
      this.setState((prev) => ({
        problems: { ...prev.problems, [id]: updated },
      }));
    } catch (err) {
      console.error(err);
      showErrorToast("Failed to update problem.");
    }
  };

  deleteProblem = async (id) => {
    try {
      await axios.delete(`${EndPoint}/library/${id}`, { withCredentials: true });
      this.setState((prev) => {
        const updated = { ...prev.problems };
        delete updated[id];
        return { problems: updated };
      });
    } catch (err) {
      console.error(err);
      showErrorToast("Failed to delete problem.");
    }
  };

  toggleCategory = async (id) => {
    const currentIndex = this.state.categoryMap[id] || 0;
    const nextIndex = (currentIndex + 1) % this.categoryOptions.length;
    const nextCategory = this.categoryOptions[nextIndex].label;

    try {
      await axios.put(`${EndPoint}/library/${id}`, {
        category: nextCategory,
      }, { withCredentials: true });

      this.setState((prev) => ({
        categoryMap: { ...prev.categoryMap, [id]: nextIndex },
        problems: {
          ...prev.problems,
          [id]: { ...prev.problems[id], category: nextCategory },
        },
      }));
    } catch (err) {
      console.error(err);
      showErrorToast("Failed to update category.");
    }
  };

  addGoalToProblem = async (id, event, type = "goal") => {
    if (event.key === "Enter") {
      const key = `${id}_${type}`;
      const text = this.state.goalInputs[key];
      if (!text?.trim()) return;

      try {
        const newEntry = {
          entry: text,
          type,
          author: this.state.author,
        };
        const res = await axios.post(`${EndPoint}/library/${id}/component`, newEntry, { withCredentials: true });
        const saved = res.data;

        this.setState((prev) => ({
          goalInputs: { ...prev.goalInputs, [key]: "" },
          problems: {
            ...prev.problems,
            [id]: {
              ...prev.problems[id],
              [`${type}s`]: [...(prev.problems[id][`${type}s`] || []), saved],
            },
          },
        }));
      } catch (err) {
        console.error(err);
        showErrorToast("Failed to add goal.");
      }
    }
  };

  deleteGoal = async (problemId, goalId) => {
    try {
      await axios.delete(`${EndPoint}/library/${problemId}/component/${goalId}`, {withCredentials: true});
      this.setState((prev) => {
        const updated = { ...prev.problems };
        Object.keys(updated[problemId]).forEach((type) => {
          if (Array.isArray(updated[problemId][type])) {
            updated[problemId][type] = updated[problemId][type].filter(
              (g) => g._id !== goalId
            );
          }
        });
        return { problems: updated };
      });
    } catch (err) {
      console.error(err);
      showErrorToast("Failed to delete goal.");
    }
  };

  saveEditedGoal = async (problemId, goalId, event) => {
    if (event.key === "Enter") {
      const newText = this.state.editingGoals[goalId];
      if (!newText?.trim()) return;

      try {
        const updated = { entry: newText };
        await axios.put(`${EndPoint}/library/${problemId}/component/${goalId}`, updated, { withCredentials: true });
        this.setState((prev) => {
          const updatedGoals = { ...prev.editingGoals };
          delete updatedGoals[goalId];

          const updatedProblem = { ...prev.problems[problemId] };
          Object.keys(updatedProblem).forEach((type) => {
            if (Array.isArray(updatedProblem[type])) {
              updatedProblem[type] = updatedProblem[type].map((g) =>
                g._id === goalId ? { ...g, ...updated } : g
              );
            }
          });

          return {
            editingGoals: updatedGoals,
            problems: { ...prev.problems, [problemId]: updatedProblem },
          };
        });
      } catch (err) {
        console.error(err);
        showErrorToast("Failed to update goal.");
      }
    }
  };

  updateProblemTextLocally = (id, newText) => {
    this.setState((prev) => ({
      problems: {
        ...prev.problems,
        [id]: { ...prev.problems[id], text: newText },
      },
    }));
  };

  handleGoalInputChange = (id, type, value) => {
    this.setState((prev) => ({
      goalInputs: { ...prev.goalInputs, [`${id}_${type}`]: value },
    }));
  };

  handleEditGoal = (goalId, text) => {
    this.setState((prev) => ({
      editingGoals: { ...prev.editingGoals, [goalId]: text },
    }));
  };

  toggleCollapse = (id) => {
    this.setState((prev) => ({
      collapsedProblems: {
        ...prev.collapsedProblems,
        [id]: !prev.collapsedProblems[id],
      },
    }));
  };
  
  handlePrint = () => {
    const allExpanded = {};
    Object.keys(this.state.problems).forEach(id => {
      allExpanded[id] = false;
    });
    this.setState({ collapsedProblems: allExpanded }, () => {
      setTimeout(() => window.print(), 100); // Delay to allow render
    });

  };
  
  renderProblemSection(label, items, id) {
    const type = label.toLowerCase();
    const inputKey = `${id}_${type}`;
  
    return (
      <div className="mb-4 bg-white p-2 rounded">
        <h2 className="text-md font-semibold mb-1 text-center bg-sky-700 text-white rounded p-2">{label}</h2>
        <div className="space-y-1">
          {items?.map((item, idx) => (
            <div
              key={item._id}
              className="bg-slate-50 text-sm p-2 my-2 rounded flex justify-between items-center"
            >
              {this.state.editingGoals[item._id] !== undefined ? (
                <input
                  className="flex-1 text-sm border border-gray-300 rounded resize-none"
                  value={this.state.editingGoals[item._id]}
                  onChange={(e) => this.handleEditGoal(item._id, e.target.value)}
                  onKeyDown={(e) => this.saveEditedGoal(id, item._id, e)}
                />
              ) : (
                <span
                onDoubleClick={
                  item.author === this.state.author
                    ? () => this.handleEditGoal(item._id, item.entry)
                    : () => showErrorToast('You are not the author of this entry. Editing is not allowed.')
                }
                  className="flex-1 cursor-pointer bg-slate-100 p-2"
                >
                  <p className="text-md my-2">{item.entry}</p>
                  <span className="text-xs italic text-gray-500">
                    {new Date(item.dateAdded).toLocaleString()} by {item.author}
                  </span>
                </span>
              )}
              {item.author === this.state.author && (   
              <button
                onClick={() => this.deleteGoal(id, item._id)}
                className="text-red-400 ml-2 hover:text-red-600 text-xs"
              >
                ✕
              </button>
              )}
            </div>
          ))}
        </div>
        {this.state.hasSubscription && (
        <input
          type="text"
          value={this.state.goalInputs[inputKey] || ""}
          onChange={(e) => this.handleGoalInputChange(id, type, e.target.value)}
          onKeyDown={(e) => this.addGoalToProblem(id, e, type)}
          placeholder={`Type in ${type} here...`}
          className=" w-[100%] border border-slate-300 rounded p-2 my-2 text-sm resize-none"
        />
        )}
     
      </div>
    );
  }
  
  renderProblems() {
    const { problems, searchQuery } = this.state;
    
    const categoryOrder = [
      "Chronic Disease",
      "Mental Health",
      "Lifestyle",
      "Substance Use",
      "Preventive",
      "Senior Health",
      "Social"
    ];
    
    const filteredProblems = Object.entries(problems)
      .filter(([id, prob]) => {
        const filter = this.state.filterCategory;
        const matchesCategory = filter === "All" || (prob.category || "") === filter;
        const matchesSearch = !searchQuery || prob.text.toLowerCase().includes(searchQuery.toLowerCase());
        return matchesCategory && matchesSearch;
      })
      .sort(([, a], [, b]) => {
        const aIndex = categoryOrder.indexOf(a.category);
        const bIndex = categoryOrder.indexOf(b.category);
        return aIndex - bIndex;
      });
    return (

        <div className="m-4 xs:m-0 sm:m-0">
          {filteredProblems.map(([id, prob]) =>  {
              const categoryIndex = this.state.categoryMap[id] ?? 0;
              const category = this.categoryOptions[categoryIndex] || this.categoryOptions[0];
   
          return (
            <div
              key={id}
              className={`bg-slate-100 p-2 m-2 border rounded shadow transition-all duration-300 overflow-hidden xs:my-2 xs:-mx-6 sm:my-2 sm:-mx-6 ${
                this.state.collapsedProblems[id] ? 'h-[56px] xs:h-[140px]' : ''
              }`}
            >
              <div className="grid grid-cols-2 items-center mb-2">
              {this.state.editingProblemId === id ? (
                  <input
                    className="flex-1 border border-sky-400 bg-white text-lg text-sky-800 font-bold px-2 rounded"
                    autoFocus
                    value={prob.text}
                    onChange={(e) => this.updateProblemTextLocally(id, e.target.value)}
                    onBlur={() => this.setState({ editingProblemId: null })}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        this.updateProblem(id, prob.text);
                        this.setState({ editingProblemId: null });
                      }
                    }}
                  />
                ) : (
                  <span
                    className="text-md text-slate-800 font-bold px-2 cursor-pointer"
                    onDoubleClick={
                      prob.author === this.state.author
                        ? () => this.setState({ editingProblemId: id })
                        : () => showErrorToast('You are not the author of this problem. Editing is not allowed.')
                    }
                  >
                    {prob.text}
                  </span>
                )}
                <div className='grid grid-cols-4'>
        
                  <button
                    onClick={
                      prob.author === this.state.author
                        ? () => this.toggleCategory(id)
                        : () => showErrorToast('You are not the author of this problem. Changing category is not allowed.')
                    }
                    className={`text-slate-800 p-2 mx-2 w-32 rounded text-sm font-semibold transition-all duration-200 xs:col-span-2 sm:col-span-2 ${category.color}`}
                  >
                    {category.label}
                  </button>
                  <button
                    onClick={() => this.toggleCollapse(id)}
                    className="text-slate-600 mx-2 hover:text-sky-700 text-sm no-print w-32 xs:col-span-2 sm:col-span-2"
                  >
                    {this.state.collapsedProblems[id] ? 'Click to expand' : 'Click to collapse'}
                  </button>
                  {prob.author === this.state.author && this.state.hasSubscription && (
                  <button
                    onClick={() => this.deleteProblem(id)}
                    className="text-red-600 p-2 mx-4 hover:text-red-700 hover:font-bold no-print xs:col-span-6 sm:col-span-6"
                  >
                    Delete
                  </button>
                  )}
                </div>
              </div>

              <div className='grid grid-cols-4 gap-4 xs:grid-cols-2 sm:grid-cols-2'>              
              {this.renderProblemSection('Goal', prob.goals, id)}
              {this.renderProblemSection('Todo', prob.todos, id)}
              {this.renderProblemSection('Referral', prob.referrals, id)}
              {this.renderProblemSection('Comment', prob.comments, id)}

              </div>
            </div>
          )})}
        </div>
 
    );
  }

  renderFullEntry() {
    const { auth } = this.props; 
    
    return (
      <>
      {auth && auth[0].role && auth[0].role.includes('admin') && (
        <div className="p-4 mb-8 border border-slate-300 rounded bg-white">
          <h2 className="text-lg font-semibold mb-2 text-slate-700">Paste Full Problem JSON</h2>
          <textarea
            value={this.state.jsonInput}
            onChange={(e) => this.setState({ jsonInput: e.target.value })}
            placeholder='Paste full JSON here (e.g. with goals, todos, etc.)'
            className="w-full h-40 p-2 border border-gray-300 rounded mb-2 font-mono text-sm"
          />
          <button
            onClick={this.submitFullEntry}
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
          >
            Submit Full Entry
          </button>
        </div>
      )}
      </>
    )
  }

  render() {
    const { credits } = this.state;

    return (
      <>

          <div className="p-8 mx-auto">
            <h1 className="text-5xl text-center text-sky-800 font-bold mb-4 no-print xs:text-3xl sm:text-3xl">
              Library of Chronic Disease Management
            </h1>
            <h3 className='mt-10 ml-20 text-2xl font-semibold text-slate-700'>Add New Problem</h3>
            <div className="grid grid-cols-4 no-print px-20 py-10 xs:p-0 xs:py-4 sm:p-0 sm:py-4">
              <label className="p-2 m-2 xs:mx-0 xs:my-2">Problem/Issue</label>
              <input
                id="step1"
                type="text"
                value={this.state.input}
                onChange={this.handleInputChange}
                className="col-span-3 border border-gray-300 rounded p-2 m-2"
                placeholder="Enter new problem"
              />
              {this.state.matchingProblems.length > 0 && (
                <div className="border border-gray-300 rounded p-2 m-2 bg-white shadow-md col-start-2 col-span-3">
                  <p className="text-gray-700 font-semibold">Existing problems:</p>
                  {this.state.matchingProblems.map((prob) => (
                    <div key={prob._id} className="p-1 border-b text-gray-800">
                      {prob.text}
                    </div>
                  ))}
                </div>
              )}

              <label className="p-2 m-2">Category</label>
              <select
                value={this.state.selectedCategory}
                onChange={(e) => this.setState({ selectedCategory: e.target.value })}
                className="col-span-3 border border-gray-300 rounded p-2 m-2"
                id="step2"
              >
                {this.categoryOptions.map((cat) => (
                  <option key={cat.label}>{cat.label}</option>
                ))}
              </select>
              <div></div>

              {this.state.hasSubscription && (
              <div className='flex flex-row w-full'>
              <button
                onClick={this.addProblem}
                className={
                  `col-span-3 bg-sky-500 text-white p-2 m-2 rounded shadow w-[98%] ` +
                  (credits < 10
                    ? "pointer-events-none opacity-40"
                    : "hover:bg-sky-600")
                }
                id="step3"
              >
                Add
              </button>
              {this.state.credits > 9 && (
              <button
                onClick={this.addProblemwithAI}
                className={
                  `col-span-3 bg-sky-500 text-white p-2 m-2 rounded shadow w-[98%] ` +
                  (credits < 10
                    ? "pointer-events-none opacity-40"
                    : "hover:bg-sky-600")
                }
                id="step3"
              >
                Add with AI 
              </button>


              )}
             
              </div>
              )}
       

            </div>

            <div className=" mb-8 ml-20 ">
              
              <label className="p-2 m-2 font-semibold">Filter by category</label>
              <select
                value={this.state.filterCategory}
                onChange={(e) => this.setState({ filterCategory: e.target.value })}
                className="border border-gray-300 rounded p-2 text-sm w-52"
              >
                <option>All</option>
                {this.categoryOptions.map((cat) => (
                  <option key={cat.label}>{cat.label}</option>
                ))}
              </select>

              <label className="p-2 ml-20 m-2 font-semibold">Search by problem</label>
              <input
                type="text"
                value={this.state.searchQuery}
                onChange={this.handleSearchChange}
                placeholder="Search problems..."
                className="border border-gray-300 rounded p-2 text-sm w-64"
                id="step4"
              />
            </div>

            {this.renderFullEntry()}
            {this.renderProblems()}
            <ToastContainer />
          </div>
   
      </>
    );
  }

}


const LibraryWithNavigation = (props) => {

  const auth = useAuth(); 
  const navigate = useNavigation();
  return <Library {...props} auth={auth} navigate={navigate}  />;
};

export default LibraryWithNavigation;

